import ContactPreference from './ContactPreference';

export default ContactPreference;
